import { useMutation } from "react-query";
import api from "../../client";
import {
  PlacementEnvironmentAddInstitutionPayload,
  PlacementEnvironmentAddInstitutionResponseData,
} from "../../types/placement-environment";

const postData = async (
  uuid: string | undefined,
  payload: PlacementEnvironmentAddInstitutionPayload,
): Promise<PlacementEnvironmentAddInstitutionResponseData> => {
  const { data } = await api.post(
    `/placement-environments/${uuid}/add-institution`,
    payload,
  );

  return data;
};

export const usePlacementEnvironmentAddInstitution = (
  uuid: string | undefined,
) => {
  return useMutation((payload: PlacementEnvironmentAddInstitutionPayload) => {
    return postData(uuid, payload);
  });
};
